"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../ApiManagerAdmin");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiComic = /** @class */ (function (_super) {
    __extends(ApiComic, _super);
    function ApiComic() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_COMIC_NEW_ID = "/api/comic/getNewId";
        _this.GET_COMIC_ALL = "/api/comic/all";
        _this.GET_COMIC = "/api/comic";
        _this.UPDATE_COMIC = "/api/comic/update";
        _this.DELETE_COMIC = "/api/comic/delete";
        _this.UPDATE_COMIC_THUMBNAIL_SORT = "/api/image/comic/thumbnail/sort";
        /**
         * 신규 comic id 발급 api
         * @param accesstoken
         * @returns
         */
        _this.getComicNewId = function (accesstoken) {
            var req = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_COMIC_NEW_ID,
            });
            return req;
        };
        /**
         * 만화 전체리스트 api
         * @param accesstoken
         * @param language
         * @returns
         */
        _this.getComicAll = function (accesstoken, language) {
            var data = {
                language: language,
            };
            var req = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_COMIC_ALL,
                data: data,
            });
            return req;
        };
        /**
         * comicId에 해당하는 만화 정보
         * @param accesstoken
         * @param language
         * @param comicId
         * @returns
         */
        _this.getComic = function (accesstoken, language, comicId) {
            var data = {
                language: language,
            };
            var req = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.GET_COMIC, "/").concat(comicId),
                data: data,
            });
            return req;
        };
        /**
       * 만화생성 API
       * @param language : 언어 설정 (en/ko)
       * @param title : 만화 제목 (string)
       * @param author : 작가 ID ([1, 5])
       * @param display : 작품 노출 여부  (0:비노출 1:노출)
       * @param isDeleted : 작품 삭제 여부  (0:정상 1:삭제됨)
       * @param score : 평점 (8.6)
       * @param description : 만화 설명 (string)
       * @param mature : 성인만화 (0:비성인 1: 성인)
       * @param accessible : 언어별 해당 작품에 접근 가능 설정 값 (number/ bit)
       * @param label : 작품 라벨 (string)
       * @param files : 작품 관련 이미지 파일  배열 ([{fileObject},{fileObject}]) type값이 order임
       * @returns
       *  {
       *      "message": "complete",
              "comicId": 56
          }
       */
        _this.updateComic = function (accesstoken, comicId, data) {
            var req = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.UPDATE_COMIC, "/").concat(comicId),
                data: data,
            });
            return req;
        };
        /**
         * 만화 Thumbnail 정렬
         * @param accesstoken
         * @param comicId
         * @param type
         * @param imageIds
         * @returns
         */
        _this.updateComicThumbnailSort = function (accesstoken, comicId, type, imageIds) {
            var data = {
                comicId: comicId,
                type: type,
                imageIds: imageIds,
            };
            var req = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.UPDATE_COMIC_THUMBNAIL_SORT,
                data: data,
            });
            return req;
        };
        /**
         * 만화 삭제 api
         * @param accesstoken
         * @param comicId
         * @returns
         */
        _this.deleteComic = function (accesstoken, comicId) {
            var req = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.DELETE_COMIC, "/").concat(comicId),
            });
            return req;
        };
        return _this;
    }
    ApiComic.getInstance = function (initValue) {
        if (!ApiComic.classInstance) {
            this.classInstance = new ApiComic(initValue);
        }
        return this.classInstance;
    };
    return ApiComic;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiComic;
